import React from 'react';
import './filter_chips.ui.scss';

export interface IFilterChipOption {
  value: string;
  label: string;
}

interface IFilterChips {
  options: IFilterChipOption[];
  value: string;
  onChange: (value: string) => void;
}

const FilterChips = (props: IFilterChips) => {
  const { options, value, onChange } = props;

  return (
    <div className="filter_chips">
      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value || 'all'}
            type="button"
            className={`filter_chip${isActive ? ' filter_chip--active' : ''}`}
            aria-pressed={isActive}
            onClick={() => !isActive && onChange(option.value)}>
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default FilterChips;
